// Sustainability 2026 (ENG-7780) — interactions scoped to the sustainability
// landing sections. Ported from the ENG-7780 design mockup.
// Loaded (deferred) by the practices and numbers sections; the init guard keeps
// it from running twice if both sections load it.
(function () {
  if (document.documentElement.hasAttribute('data-sus-2026-init')) return;

  var practices = document.querySelector('.sus-practices');
  var revealEls = document.querySelectorAll('.sus-practices .reveal, .sus-numbers .reveal');
  if (!practices && !revealEls.length) return;

  document.documentElement.setAttribute('data-sus-2026-init', '');

  // ── Horizontal scroll arrows (desktop) ──
  if (practices) {
    var track = practices.querySelector('#sus-track');
    var prevBtn = practices.querySelector('[data-scroll-arrow="prev"]');
    var nextBtn = practices.querySelector('[data-scroll-arrow="next"]');

    if (track && prevBtn && nextBtn) {
      var scrollAmount = function () {
        var item = track.querySelector('.sus-card');
        return item ? item.offsetWidth + 16 : 320;
      };
      var updateButtons = function () {
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      };
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { updateButtons(); raf = null; });
      }, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }
  }

  // ── Reveal on scroll (staggers cards / number cells, fades leaf elements) ──
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var children = el.querySelectorAll('.sus-card, .sus-number-cell');
      if (children.length > 0) {
        el.style.opacity = '1';
        el.style.transform = 'none';
        children.forEach(function (child, idx) {
          child.style.opacity = '0';
          child.style.transform = 'translateY(14px)';
          child.style.transition = 'opacity 500ms ease-out, transform 500ms ease-out';
          child.style.transitionDelay = (Math.min(idx, 7) * 60) + 'ms';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              child.style.opacity = '1';
              child.style.transform = 'translateY(0)';
            });
          });
        });
      } else {
        el.classList.add('visible');
      }
      observer.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  revealEls.forEach(function (el) {
    // Scroll tracks must stay visible so overflow works — only children stagger.
    if (el.classList.contains('sus-scroll-track')) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    }
    observer.observe(el);
  });
})();
